import React from 'react';
import { __log } from '../../helpers/utils';

const ResponsiveImage = ({ imageThumbnail, defaultImage, altText }) => {
  const isDefaultImage = imageThumbnail === defaultImage;
  const imageComponent = getImageComponent(imageThumbnail || defaultImage, defaultImage, isDefaultImage, altText);

  return (
    <div>
      {imageComponent}
    </div>
  );
};

const getImageComponent = (imageSrc, defaultImage, isDefaultImage, altText) => {
  try {
    const url = new URL(imageSrc);
    const hostname = url?.hostname;

    let modifiedImageSrc = imageSrc;
    let srcset = ''; // Declare srcset variable here
    let sizes = ''; // Declare sizes variable here

    if (hostname === 'cdn.images.express.co.uk' || isDefaultImage) {
      modifiedImageSrc = imageSrc.replace('.jpg', '.webp');
    } else if (hostname === 'd4oy8w59p2l43.cloudfront.net' || hostname === 'images-cropper-prod.inyourarea.co.uk') {
      modifiedImageSrc = imageSrc;
    } else {
      const replaceImageSrc = (src, modifier) => {
        if (!src) return src;

        let updatedSrc = src;

        // 1. Replace size only in known path pattern (preferred, safest)
        if (/ALTERNATES\/s\d+d?\//.test(updatedSrc)) {
          updatedSrc = updatedSrc.replace(
            /(ALTERNATES\/)s\d+d?(\/)/,
            `$1${modifier}$2`
          );
        } else {
          // 2. Fallback: replace last occurrence of s### or s###d before filename
          updatedSrc = updatedSrc.replace(
            /\/s\d+d?(?=\/[^/]+$)/,
            `/${modifier}`
          );
        }

        // 3. Normalise extension to webp (safe + modern)
        updatedSrc = updatedSrc.replace(/\.(jpg|jpeg|png)$/i, '.webp');

        return updatedSrc;
      };
      srcset = `${replaceImageSrc(imageSrc, 'r250')} 250w, ${replaceImageSrc(imageSrc, 'r500')} 500w`; // Assign srcset value here
      sizes = '(max-width: 1913px) 300px, 100vw'; // Assign sizes value here
      modifiedImageSrc = replaceImageSrc(imageSrc, 'r500');
    }

    return (
      <img
        className="teaser-img search--img-container i-amphtml-fill-content i-amphtml-replaced-content"
        decoding="async"
        alt={altText || ''}
        src={modifiedImageSrc}
        srcSet={!isDefaultImage ? srcset : null} // Generate srcset only if it's not the default image
        sizes={sizes}
      />
    );
  } catch (error) {
    // Handle the error here, for example by returning a default image or an error message
    __log(error);
    return (
      <img
        className="teaser-img search--img-container i-amphtml-fill-content i-amphtml-replaced-content"
        decoding="async"
        alt={altText || ''}
        src={defaultImage}
      />
    );
  }
};

export default ResponsiveImage;
